<template>
  <!--srcviewshomeindexvuehtmlStart-->

  <div id="defaultId1">
    <!-- 轮播图背景 -->
 
   
    <!-- 头部 -->
    <div id="gd4c8e" class="u8c4dc">
      <div id="u8220d" class="u8220d">
         <div class="menu-icon margin-left15" @click="drawer = true" >
          <div class="menu-round-con" v-for="item in 3" :key="item">
            <div class="menu-round-item"></div>
            <div class="menu-round-item"></div>
            <div class="menu-round-item"></div>
          </div>
        </div>
        <!-- <svg t="1750927517285" class="icon margin-right40 margin-left15" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="19470" width="33" height="33"><path d="M853.333333 938.666667c-46.933333 0-85.333333-38.4-85.333333-85.333334s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333334 85.333333-38.4 85.333333-85.333334 85.333334z m0-341.333334c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333334 85.333333-38.4 85.333333-85.333334 85.333333z m0-341.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333334 85.333333 38.4 85.333334 85.333334-38.4 85.333333-85.333334 85.333333z m-341.333333 682.666667c-46.933333 0-85.333333-38.4-85.333333-85.333334s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333334z m0-341.333334c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333333z m0-341.333333c-46.933333 0-85.333333-38.4-85.333333-85.333333s38.4-85.333333 85.333333-85.333334 85.333333 38.4 85.333333 85.333334-38.4 85.333333-85.333333 85.333333zM170.666667 938.666667c-46.933333 0-85.333333-38.4-85.333334-85.333334s38.4-85.333333 85.333334-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333334z m0-341.333334c-46.933333 0-85.333333-38.4-85.333334-85.333333s38.4-85.333333 85.333334-85.333333 85.333333 38.4 85.333333 85.333333-38.4 85.333333-85.333333 85.333333z m0-341.333333c-46.933333 0-85.333333-38.4-85.333334-85.333333s38.4-85.333333 85.333334-85.333334 85.333333 38.4 85.333333 85.333334-38.4 85.333333-85.333333 85.333333z" p-id="19471" fill="#ffffff"></path></svg> -->
   
   
        <img id="g063ad" @click="goHome()" src="../../assets/images/newPage/home-logo.png" alt="" />
        <span class="head-text-title"  v-if="this.$route.query.Detail == 'Trade'">{{ $t('Home.SearchTrade') }}</span>
            <span class="head-text-title"  v-else>{{ $t('Home.SearchCompanies') }}</span>
      </div>
      <div id="g50128" class="u2042e"></div>
        <div id="cda00e" >
        <div class=" fontffffff font16  cuspoint textCenter WhatNew" @click="OpenWhatNew('')">What's New?</div>
    
      </div>
        <div id="cda00e " class="right_menu_box"  v-if="$store.state.app.OperationWarning">
       <el-popover placement="bottom" width="200" trigger="hover" :disabled="!loginStatus" >
        <div class="u9qMull" >Operation Warning</div>
        <svg t="1755585999252" @click="OperationWarningShow" style="margin-top: 0.214em;"  slot="reference" class="icon " viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7131" width="24" height="24"><path d="M512 179.2l390.4 627.2H128l384-627.2m0-64c-19.2 0-44.8 12.8-51.2 32l-390.4 627.2c-25.6 44.8 6.4 96 51.2 96H896c51.2 0 83.2-57.6 51.2-96l-384-627.2c-6.4-19.2-32-32-51.2-32z" fill="#FFC800" p-id="7132"></path><path d="M512 640c-19.2 0-32-12.8-32-32v-192c0-19.2 12.8-32 32-32s32 12.8 32 32v192c0 19.2-12.8 32-32 32z" fill="#FFC800" p-id="7133"></path><path d="M512 723.2m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z" fill="#FFC800" p-id="7134"></path></svg>
     </el-popover>
      </div>
      <div v-if="userInfo?.userInfo?.userType == '3'" id="g4f869" class="right_menu_box"
        @click="loginStatus ? '' : (loginDialog = true)">
        <div id="cda00e" class="                   ">
          <el-dropdown id="idMW7CnK" trigger="click" class="" placement="bottom">
            <div id="id1bXcm9">
              <svg @click="loginStatus ? '' : gotoUSer('/')" slot="reference" id="id1wIih1" class="icon "
                t="1708929823979" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18274"
                width="1.987em" height="26px">
                <path id="idCG1WrO"
                  d="M700.472 624.178c-34.774-34.774-75.275-62.079-120.379-81.156a377.62 377.62 0 0 0-40.215-14.395c18.671-10.183 35.995-23.096 51.453-38.554 42.382-42.382 65.723-98.731 65.723-158.668s-23.341-116.286-65.723-158.668c-42.381-42.381-98.73-65.722-158.667-65.722s-116.287 23.341-158.668 65.722c-42.382 42.382-65.723 98.731-65.723 158.668s23.341 116.287 65.723 158.668c15.458 15.458 32.782 28.371 51.453 38.554a377.4 377.4 0 0 0-40.215 14.395c-45.103 19.077-85.604 46.382-120.378 81.156-34.775 34.774-62.08 75.276-81.157 120.379-19.756 46.709-29.773 96.312-29.773 147.43 0 13.808 11.193 25 25 25s25-11.192 25-25c0-181.267 147.471-328.738 328.738-328.738 181.266 0 328.738 147.472 328.738 328.738 0 13.808 11.193 25 25 25s25-11.192 25-25c0-51.118-10.018-100.721-29.773-147.43-19.078-45.103-46.383-85.605-81.157-120.379zM258.273 331.404c0-96.159 78.231-174.39 174.391-174.39 96.159 0 174.39 78.231 174.39 174.39s-78.231 174.391-174.39 174.391c-96.16 0-174.391-78.232-174.391-174.391z"
                  p-id="5361" fill="#FFFFFF"></path>
                <path id="idrrFDpK"
                  d="M949.595 723.902c-15.027-41.062-37.593-78.38-67.072-110.92-29.479-32.54-64.394-58.672-103.775-77.67a337.59 337.59 0 0 0-28.944-12.317c14.958-7.855 29.021-17.659 41.87-29.301 39.892-36.138 63.322-85.648 65.976-139.409 2.654-53.761-15.787-105.338-51.925-145.229-36.139-39.891-85.648-63.322-139.41-65.976-13.783-0.672-25.521 9.947-26.202 23.737-0.681 13.79 9.947 25.521 23.737 26.202 40.422 1.995 77.647 19.612 104.819 49.605 27.172 29.993 41.037 68.772 39.041 109.194-1.995 40.422-19.611 77.647-49.604 104.819-28.099 25.455-63.902 39.232-101.549 39.23-2.539 0-5.093-0.063-7.646-0.189-13.786-0.677-25.521 9.947-26.202 23.737a25.25 25.25 0 0 0 0.061 3.307 25.096 25.096 0 0 0-0.386 3.283c-0.681 13.79 9.947 25.521 23.737 26.202 76.875 3.795 147.671 37.299 199.347 94.341s78.045 130.793 74.25 207.668c-0.681 13.79 9.947 25.521 23.737 26.202 0.42 0.021 0.837 0.031 1.253 0.031 13.24 0 24.289-10.398 24.949-23.769 2.249-45.579-4.501-90.253-20.062-132.778z"
                  p-id="5362" fill="#FFFFFF"></path>
              </svg>
            </div>
            <el-dropdown-menu id="idKKFx11" slot="dropdown" v-if="loginStatus">
              <el-dropdown-item id="idAUoVwu">
                <span class="u9qMull" @click="gotoUSer('/account/userGroup')">Group Account</span>
              </el-dropdown-item>
              <el-dropdown-item id="idAUoVwu">
                <span class="u9qMull" @click="gotoUSer('/account/user')">User Account</span> </el-dropdown-item>
              <el-dropdown-item id="idAUoVwu">
                <span class="u9qMull" @click="gotoUSer('/account/roles')">Roles</span>
              </el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!-- 超出限制 -->
     
      <div id="g4f869" class="right_menu_box" @click="loginStatus ? '' : (loginDialog = true)">
        <el-badge :value="loginStatus ? RedNews.length : ''" class="item" :hidden="RedNews.length == 0">
          <el-popover placement="bottom" width="430" trigger="click">
            <div class="cas_panel" v-if="loginStatus">
              <div class="flex_center_between_box history_box-headborder">
                <div style="display: flex">
                  <h2 class="history_box-head">
                    <el-badge :value="RedNews.length" :hidden="RedNews.length == 0" class="item" type="warning">
                      {{ $t('navigationBar.Notifications') }}
                    </el-badge>
                  </h2>
                </div>
              </div>
              <div class="history_box">
                <div class="item_title" v-for="(item, index) in Newlist" :key="index">
                  <div class="flex_box" @click="gotomessage(item)">
                    <img src="@/assets/img/csi头像.png" class="messageimg" alt="" />
                    <div class="message-right">
                      <div class="head-text">
                        <!-- <span class="icon-time head-text"
                        >Thanks for your revies of </span
                      > -->
                        {{ item.title }}
                      </div>
                      <div class="icon-time">{{ item.createTime }}</div>
                    </div>
                    <div v-if="item.hasRead == 0" class="right-blue"></div>
                  </div>
                </div>

              </div>

              <div class="history_box_bottom flex_center_between_box">
                <button @click="MarkRead()" class="btn_blue btn_write flex_center">
                  <svg t="1723168823188" class="icontwo" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="5443" width="18" height="18">
                    <path
                      d="M921.6 512h-41l92.2 460.8c0 28.3-22.9 51.2-51.2 51.2H102.4c-28.3 0-51.2-22.9-51.2-51.2L143.4 512h-41c-28.3 0-51.2-22.9-51.2-51.2v-51.2c0-28.3 22.9-51.2 51.2-51.2h307.2v-256C409.6 45.8 455.4 0 512 0s102.4 45.8 102.4 102.4v256h307.2c28.3 0 51.2 22.9 51.2 51.2v51.2c0 28.3-22.9 51.2-51.2 51.2zM102.4 972.8h155.2c-3.7-5.5-5.2-12.1-4.1-18.6l31.2-227.6c1.9-14 14.8-23.8 28.8-21.9 14 1.9 23.8 14.8 21.9 28.8-0.1 0.6-0.2 1.3-0.3 1.9l-31 227.6c-0.6 3.5-1.9 6.8-3.9 9.7h621.4L819.2 512H204.8L102.4 972.8z m460.8-870.4c0-28.3-22.9-51.2-51.2-51.2s-51.2 22.9-51.2 51.2v256h102.4v-256z m358.4 307.2H102.4v51.2h819.2v-51.2z"
                      fill="#1A2332" p-id="5444"></path>
                  </svg>

                       {{ $t('navigationBar.MarkasRead') }}
                </button>
                <button class="btn_blue flex_center" @click="gotoUSer('/account/notifications')">
                  {{ $t('navigationBar.Viewall') }}
                </button>
              </div>
            </div>
            <svg t="1734672348781" slot="reference" style="margin-top: 0.214em;" id="idThqehh" class="icon"
              viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5864" width="1.571em"
              height="1.571em">
              <path
                d="M511.964861 0c101.601754 0 197.851147 35.884083 271.01558 101.043247 71.163116 63.390558 112.4461 147.306253 116.867615 237.03973a39.514379 39.514379 0 0 1 0.372338 5.073106v9.308452c0.093085 1.582437 0.046542 3.211416-0.093085 4.793853v4.002635c-0.279254 104.301205 31.974533 206.089128 93.27069 294.333252l5.910867 8.470691c30.624807 44.07552 32.812293 97.831831 5.864324 143.815584-27.227222 46.402633-79.866518 75.258835-137.439294 75.258835H156.195825c-57.572776 0-110.212072-28.856201-137.439294-75.258835-26.947969-45.983753-24.760482-99.740063 5.864325-143.815584l5.910867-8.470691c61.296156-88.244125 93.549943-190.032048 93.270689-294.333252v-4.374973a31.834906 31.834906 0 0 1-0.093085-2.839078V343.156083c0-1.722064 0.139627-3.397585 0.372338-5.073106 4.421515-89.733477 45.704499-173.60263 116.867615-237.03973C314.160255 35.884083 410.363107 0 511.964861 0z m0 68.277495c-169.506911 0-310.576501 125.012511-314.718763 278.741596v5.724698l0.046542 8.377607c0.279254 117.519207-36.023709 232.152793-105.045881 331.520518l-5.910867 8.470691a67.34665 67.34665 0 0 0-3.025247 74.095278c14.521185 24.807025 41.79495 39.654006 72.88518 39.654006h711.538071c31.09023 0 58.363994-14.846981 72.88518-39.654006a67.34665 67.34665 0 0 0-3.025247-74.095278l-5.910867-8.470691c-69.022172-99.367725-105.325135-214.001312-105.045881-331.520518v-14.102305c-4.095719-153.729085-145.211851-278.741595-314.67222-278.741596z m245.882759 882.394709H266.082101a36.675301 36.675301 0 1 0 0 73.257517h491.765519a36.675301 36.675301 0 1 0 0-73.257517z"
                fill="#FFFFFF" p-id="5865"></path>
            </svg>
   
          </el-popover>
        </el-badge>
      </div>
      <div id="g4f869" class="right_menu_box" @click="loginStatus ? '' : (loginDialog = true)">
        <el-popover placement="bottom" width="500" trigger="click">
          <div style="padding: 8px">
            <div class="flex_center_start_box">
              <div class="postiverelatibve avatarnologin">
                <img :src="imageUrl" v-if="imageUrl" class="avatar" />
                <div v-else class="avatar avatartex">
                  {{ userInfo?.userInfo?.firstName }}
                </div>
                <img v-if="lockType == 1" src="../../assets/img/vip.png" class="postiveaboust" />
                <img v-if="lockType == 2" src="../../assets/img/jinvip.png" class="postiveaboust" />
                <!-- <img src="../../../assets/img/accountusericon.png" alt=""> -->
              </div>
              <div class="account-left-right">
                <h3>
                  {{ userInfo?.userInfo?.firstName
                  }}{{ userInfo?.userInfo?.lastName }}
                </h3>
                <h4 v-if="lockType == 2" style="color: #BC8553;">
                 {{ $t('navigationBar.GoldSubscriber') }}
                </h4>
                <h4 v-if="lockType == 1" style="color: #7186B1;">
                   {{ $t('navigationBar.SilverSubscriber') }}
                </h4>
                <h4 v-if="lockType == 0">
                  Ordinary users
                </h4>
              </div>
            </div>
            <div>
              <div v-if="Vips.length == 0">
                <el-progress :stroke-width="10" class="progress" :percentage="0" :color="'#1290C9'" :show-text="false"
                  define-back-color="#DDDDDD"></el-progress>


              </div>
              <div v-for="(item, index) in Vips" :key="index" style="position: relative;">
                <el-progress :stroke-width="10" class="progress" :percentage="(item.dayUsed / (item.totalDays)) * 100"
                  :color="item.lockType == 2 ? '#FFA000' : '#1290C9'" :show-text="false"
                  define-back-color="#DDDDDD"></el-progress>
                <svg :style="{ position: 'absolute', top: '0px', left: (item.dayUsed / (item.totalDays)) * 100 + '%' }"
                  v-if="item.lockType == 1 && Vips.length > 1" t="1727058168966" class="icon" viewBox="0 0 1024 1024"
                  version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5567" id="mx_n_1727058168967" width="12"
                  height="12">
                  <path
                    d="M763.776 968.96H261.504C147.456 968.96 55.04 876.544 55.04 762.496V260.224C55.04 146.176 147.456 53.76 261.504 53.76h502.272C877.824 53.76 970.24 146.176 970.24 260.224v502.272c0 114.048-92.416 206.464-206.464 206.464z"
                    fill="#FF4D3C" p-id="5568"></path>
                  <path
                    d="M512.64 252.8c-142.592 0-258.56 115.968-258.56 258.56s115.968 258.56 258.56 258.56 258.56-115.968 258.56-258.56-115.968-258.56-258.56-258.56z m-194.688 258.56c0-42.24 13.568-81.152 36.48-113.024l271.36 271.36c-31.872 22.912-70.912 36.48-113.024 36.48-107.52 0-194.816-87.424-194.816-194.816z m352.896 113.152l-271.36-271.36c31.872-22.912 70.912-36.48 113.024-36.48 107.392 0 194.688 87.424 194.688 194.688 0.128 42.24-13.44 81.152-36.352 113.152z"
                    fill="#FFFFFF" p-id="5569"></path>
                </svg>

                <h4 v-if="item.lockType == 2" class="ExpireDate"> {{ $t('navigationBar.Goldsubscriptiondate') }} : {{ item.endTime }} ({{
                  item.dayUsed }}/{{ item.totalDays }})</h4>
                <h4 v-else class="ExpireDate">{{ $t('navigationBar.Silversubscriberdate') }} : {{ item.endTime }} ({{ item.dayUsed }}/{{
                  item.totalDays }})</h4>
              </div>

              <div class="Available flex_center_start_box">
                <img src="../../assets/img/jifen.png" alt="" class="margin10" />{{ $t('navigationBar.AvailableCredits') }}: {{
                  $store.state.app.equityType }}
              </div>
              <button v-if="userInfo?.userInfo?.userType != 2" style="width: 100%" @click="gotoUSer('/index/addCredit')"
                class="btn_blue flex_center">
               {{ $t('navigationBar.AddCredits') }}
              </button>
            </div>
          </div>

          <svg slot="reference" id="idONDSqC" class="icon " t="1716880662137" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="5859" width="1.99rem" height="1.99rem">
            <path id="idRwKoi7"
              d="M512 896c212.078933 0 384-171.921067 384-384s-171.921067-384-384-384-384 171.921067-384 384 171.921067 384 384 384z m0 42.666667c-235.639467 0-426.666667-191.0272-426.666667-426.666667S276.360533 85.333333 512 85.333333s426.666667 191.0272 426.666667 426.666667-191.0272 426.666667-426.666667 426.666667z"
              fill="#ffffff" p-id="5860"></path>
            <path id="id19vpOq"
              d="M512 797.866667c157.879467 0 285.866667-127.9872 285.866667-285.866667s-127.9872-285.866667-285.866667-285.866667-285.866667 127.9872-285.866667 285.866667 127.9872 285.866667 285.866667 285.866667z m0 42.666666c-181.444267 0-328.533333-147.089067-328.533333-328.533333s147.089067-328.533333 328.533333-328.533333 328.533333 147.089067 328.533333 328.533333-147.089067 328.533333-328.533333 328.533333z"
              fill="#ffffff" p-id="5861"></path>
            <path id="id3SVEJN"
              d="M533.333333 683.968c41.365333-10.346667 72.644267-47.044267 74.210134-91.7888 1.890133-54.161067-40.4864-99.605333-94.651734-101.495467a21.589333 21.589333 0 0 0-2.133333 0.029867 21.589333 21.589333 0 0 0-2.129067-0.1792c-28.258133-0.989867-50.368-24.695467-49.3824-52.957867 0.9856-28.258133 24.695467-50.368 52.957867-49.3824 28.258133 0.989867 50.368 24.695467 49.378133 52.957867a21.333333 21.333333 0 0 0 42.641067 1.489067c1.578667-45.047467-28.864-83.7888-70.890667-94.3232V328.533333a21.333333 21.333333 0 1 0-42.666666 0v19.042134c-41.088 8.8064-72.5248 44.612267-74.0608 88.512-1.809067 51.810133 38.724267 95.274667 90.5344 97.088 0.721067 0.0256 1.4336 0.0128 2.133333-0.034134 0.699733 0.093867 1.408 0.157867 2.133333 0.183467 30.613333 1.066667 54.562133 26.752 53.495467 57.365333-1.066667 30.6176-26.752 54.570667-57.3696 53.499734-30.613333-1.066667-54.5664-26.752-53.495467-57.3696a21.333333 21.333333 0 1 0-42.641066-1.489067c-1.706667 48.917333 32.6912 90.722133 79.2704 99.754667V704a21.333333 21.333333 0 1 0 42.666666 0v-20.032z"
              fill="#ffffff" p-id="5862"></path>
          </svg>
        </el-popover>
      </div>
      <div id="c21d14" class="right_menu_box ub08be" @click="loginStatus ? '' : (loginDialog = true)">
        <el-dropdown id="idMW7CnK" trigger="click" class="" placement="bottom">
          <div id="id1bXcm9">
            <svg t="1724132771458" slot="reference" class="icon " viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="5604" width="1.9285rem" height="1.857rem">
              <path
                d="M257.706667 343.04h184.32V392.533333h-124.586667v69.973334h105.813333v51.2h-105.813333v80.213333h129.706667v51.2H257.706667V343.04zM506.88 343.04h61.44l87.04 160.426667 30.72 64.853333h1.706667c-3.413333-30.72-8.533333-71.68-8.533334-105.813333v-119.466667h56.32v302.08h-61.44l-87.04-162.133333-30.72-64.853334h-1.706666c3.413333 32.426667 6.826667 69.973333 6.826666 105.813334v121.173333h-56.32V343.04z"
                fill="#ffffff" p-id="5605"></path>
              <path
                d="M498.346667 933.546667C250.88 933.546667 51.2 732.16 51.2 486.4S250.88 39.253333 498.346667 39.253333 945.493333 238.933333 945.493333 486.4c0 37.546667-5.12 73.386667-13.653333 109.226667-3.413333 13.653333-17.066667 22.186667-30.72 18.773333-13.653333-3.413333-22.186667-17.066667-18.773333-30.72 8.533333-30.72 11.946667-63.146667 11.946666-97.28C894.293333 267.946667 716.8 90.453333 498.346667 90.453333S102.4 267.946667 102.4 486.4s177.493333 395.946667 395.946667 395.946667c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6z"
                fill="#ffffff" p-id="5606"></path>
              <path
                d="M947.2 795.306667H629.76c-13.653333 0-25.6-11.946667-25.6-25.6s11.946667-25.6 25.6-25.6h264.533333l-30.72-39.253334c-8.533333-11.946667-6.826667-27.306667 5.12-35.84 10.24-8.533333 27.306667-6.826667 35.84 5.12l64.853334 81.92c6.826667 8.533333 6.826667 18.773333 3.413333 27.306667s-15.36 11.946667-25.6 11.946667zM694.613333 983.04c-6.826667 0-15.36-3.413333-20.48-10.24l-64.853333-81.92c-6.826667-8.533333-6.826667-18.773333-3.413333-27.306667s13.653333-13.653333 22.186666-13.653333h317.44c13.653333 0 25.6 11.946667 25.6 25.6s-11.946667 25.6-25.6 25.6H682.666667l30.72 39.253333c8.533333 11.946667 6.826667 27.306667-5.12 35.84-3.413333 5.12-8.533333 6.826667-13.653334 6.826667z"
                fill="#ffffff" p-id="5607"></path>
            </svg>
          </div>
          <el-dropdown-menu id="idKKFx11" class="uWDPJiJ" slot="dropdown" v-if="loginStatus">
            <el-dropdown-item id="idAUoVwu" v-for="(item, index) in languageList" :key="index">
              <!---->
              <button id="cf870f"  class="u606de"  @click="selectLanguage(item)"  :disabled="item.countryName == 'Japanese'">
                <div style="display: flex;align-items: center;">
                  <img style="width:2.1428rem;height: 1.42857rem;margin-right: 0.714rem;"
                    :src="require('../../../static' + getCountryImgUrl(item.countryCodeImg))" alt="">
                  <div :class="item.color ? 'activecolor' : ''">
                    {{ item.countryName }}
                  </div>
                </div>
        
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div id="c19534" class="right_menu_box ub08be" @click="loginStatus ? '' : (loginDialog = true)">
        <el-dropdown id="idMW7CnK" trigger="click" class="" placement="bottom">
          <div id="id1bXcm9">
            <svg id="idRVBnvj" class="icon" t="1718860833955" viewBox="0 0 1059 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4934" width="1.571rem" height="1.857rem">
              <path id="idDKpSGV"
                d="M547.326184 788.934951m-54.851338 0a54.851338 54.851338 0 1 0 109.702676 0 54.851338 54.851338 0 1 0-109.702676 0Z"
                p-id="4935" fill="#ffffff"></path>
              <path id="idxbhkCU"
                d="M547.326184 184.213435c-100.826964 0-182.856638 81.294743-182.856638 181.217175a36.576981 36.576981 0 0 0 73.153962 0c0-60.603591 48.194554-108.063213 109.702676-108.063213 60.490525 0 109.71681 49.59375 109.716809 110.550674 0 24.394076-30.612728 54.964405-60.193725 84.587802-40.378839 40.336439-86.085932 86.043532-86.085932 145.883925v61.847321a36.576981 36.576981 0 1 0 73.139829 0v-61.889721c0-29.510331 32.84579-62.356121 64.659848-94.08538 40.110306-40.124439 81.619809-81.591542 81.619809-136.343947 0-101.307496-82.029674-183.704636-182.856638-183.704636z"
                p-id="4936" fill="#ffffff"></path>
              <path id="idXBaO2a"
                d="M547.326184 0C264.999379 0 35.333251 229.666128 35.333251 511.992933a509.10974 509.10974 0 0 0 90.241121 289.972921L6.656784 967.071067A35.333251 35.333251 0 0 0 35.333251 1023.038936l466.031441-0.183733v0.268532c15.687963 0.240266 30.471395 0.862131 45.961492 0.862132 282.326805 0 512.007067-229.666128 512.007067-511.992934S829.667122 0 547.326184 0z m11.377307 950.379639l-4.395457 0.0848c-2.317861 0-5.215188 0.282666-7.547182 0.409866-17.313293 0.890398-29.67993 1.158931-45.39616 1.045864v0.282666l-397.018537 0.1696 95.187777-132.146357a35.333251 35.333251 0 0 0-3.476792-45.424427l0.240267-0.2544a436.238444 436.238444 0 0 1-87.485129-262.526051C108.812278 270.214567 305.533684 73.493161 547.340317 73.493161s438.513906 196.693139 438.513906 438.499772c0 237.976509-190.61582 432.32352-427.150732 438.386706z"
                p-id="4937" fill="#ffffff"></path>
            </svg>
          </div>
          <el-dropdown-menu id="idKKFx11" slot="dropdown" v-if="loginStatus">
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/fAQ')">{{ $t('AccountCenterMenu.FAQ') }} </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/privacyPolicy')">{{ $t('AccountCenterMenu.Privacy') }} </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span @click="gotoUSer('/account/terms')">{{ $t('AccountCenterMenu.Terms') }} </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="lockType == 0 ? hasPrivilege = true : gotoUSer('/account/reportaproblem')">
              {{ $t('AccountCenterMenu.ReportIssues') }}
              </span>
            </el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull"
                @click="lockType != 2 ? hasPrivilege = true : gotoUSer('/account/instructions')">{{ $t('AccountCenterMenu.UserGuide') }}
              </span></el-dropdown-item>
            <el-dropdown-item id="idAUoVwu">
              <span class="u9qMull" @click="gotoUSer('/account/About')">{{ $t('AccountCenterMenu.AboutCSI') }}
              </span></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div id="g6b102" :class="loginStatus ? 'margin-left20 u1ba31' : 'margin-left30'" v-if="!loginStatus"
        @click="loginStatus ? '' : (loginDialog = true)">
        <div id="ga2883">
          <div id="g7b8d7" class="u0427c">
            <div id="gc941a" class="u84443" v-if="!loginStatus" @click="Sign">
              {{ loginStatus ?  $t('MyAccount.SignOut') : "Sign in" }}
            </div>

            <div id="g7e8e5" class="ubbf89">
              <svg t="1727149438668" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5432" width="1.5em" height="1.5em">
                <path
                  d="M899.64 897.715c-7.238-108.133-60.68-208.738-146.61-276.032l-5.165-3.568-0.047 0.07c-4.887-2.989-10.458-4.587-16.193-4.587-19.702 0-31.458 9.498-31.458 25.412 0 9.266 4.285 17.975 11.477 23.883l-0.08 0.139 4.562 3.266c72.065 51.519 112.638 129.653 120.584 232.273l0.085 1.12a31.507 31.507 0 0 0-0.116 2.612c0 17.341 14.058 31.4 31.4 31.4 16.76 0 30.45-13.13 31.35-29.665h0.624l-0.412-6.323z m-101.124-525.92c0-156.107-128.53-283.118-286.525-283.118S225.465 215.688 225.465 371.796c0 84.11 37.191 162.57 102.378 216.66-117.017 62.453-194.688 181.59-203.48 313.119l-0.362 5.483c-0.007 0.113-0.016 0.226-0.022 0.34l-0.033 0.5h0.02c-0.009 0.267-0.02 0.533-0.02 0.802 0 14.703 11.918 26.622 26.622 26.622 14.703 0 26.623-11.918 26.623-26.622 0-0.27-0.013-0.535-0.02-0.802h0.554l0.417-5.468c9.648-124.998 88.871-234.45 202.112-279.553 33.81 15.706 85.42 32.06 131.715 32.06 42.89 0 84.54-9.45 124.199-28.307l29.049-16.863 23.72-15.567c69.63-54.203 109.579-135.28 109.579-222.404zM511.99 597.932c-126.248 0-228.95-101.462-228.95-226.158 0-124.673 102.701-226.112 228.95-226.112 126.26 0 228.973 101.439 228.973 226.112-0.001 124.696-102.714 226.158-228.973 226.158z"
                  p-id="5433" fill="#FFFFFF"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div id="g6b101" class="right_menu_box u1ba31" v-if="loginStatus"
        @click="loginStatus ? '' : (loginDialog = true)">
        <div id="cda00e" class="icon ">
          <el-dropdown id="idMW7CnK" trigger="click" placement="bottom">
            <div id="id1bXcm9">
              <svg id="idxPwMuF" v-show="headPortrait" class="icon" t="1716880974917" viewBox="0 0 1024 1024"
                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7415" width="1.71em" height="1.71em">
                <path id="iddvqpfq" d="M540.842397 542.300097" p-id="7416"></path>
                <path id="id7VqerN"
                  d="M256.722454 336.343351c0-137.247874 113.578802-248.478188 253.686816-248.478188 140.119271 0 253.686816 111.230314 253.686816 248.478188 0 137.226385-113.567545 248.473071-253.686816 248.473071C370.307396 584.821539 256.722454 473.568712 256.722454 336.343351L256.722454 336.343351 256.722454 336.343351zM211.951785 336.343351c0 117.863385 71.251787 219.473597 173.847443 265.72806-172.775019 48.938596-302.560944 197.078541-320.840262 377.394303l44.989657 0c22.275329-197.319018 193.054901-350.796528 400.459624-350.796528s378.189412 153.476487 400.460648 350.796528l44.989657 0C937.591513 799.148929 807.793308 651.010007 635.020336 602.071412c102.594633-46.249347 173.85256-147.864676 173.85256-265.72806 0-161.450089-133.629463-292.324812-298.462602-292.324812C345.572038 44.017516 211.951785 174.888146 211.951785 336.343351L211.951785 336.343351 211.951785 336.343351zM211.951785 336.343351"
                  p-id="7417"></path>
              </svg>

              <div v-if="loginStatus" class="avatarnologin">
                <img :src="imageUrl" v-if="imageUrl" class="avatar" />
                <div v-else class="avatar avatartex avatarnologin">
                  <div class="avatarnologin_1">
                    {{ userInfo?.userInfo?.firstName }}
                  </div>

                </div>
              </div>
            </div>
            <el-dropdown-menu id="idKKFx11" slot="dropdown" v-if="loginStatus">
              <el-dropdown-item id="idAUoVwu">
                <div style="padding: 0.714rem 0px">
                  <div class="flex_center_star">
                    <div class="postiverelatibve avatarnologin"
                      style="height: 4.285714285714286rem;width: 4.285714285714286rem;line-height: 4.285714285714286rem;">
                      <img :src="imageUrl" v-if="imageUrl"
                        style="height: 4.285714285714286rem;width: 4.285714285714286rem;line-height: 4.285714285714286rem;"
                        class="avatar" />
                      <div v-else class="avatar avatartex"
                        style="height: 4.285714285714286rem;width: 4.285714285714286rem;line-height: 4.285714285714286rem;overflow: hidden;">
                        {{ userInfo?.userInfo?.firstName }}
                      </div>
                      <img v-if="lockType == 1" src="../../assets/img/vip.png" class="postiveaboust" />
                      <img v-if="lockType == 2" src="../../assets/img/jinvip.png" class="postiveaboust" />
                      <!-- <img src="../../assets/img/accountusericon.png" alt=""> -->
                    </div>
                    <div class="account-left-right">
                      <!-- v-if="userInfo?.userInfo?.userType == '1'" -->
                      <h3>
                        {{ userInfo?.userInfo?.firstName }} {{ userInfo?.userInfo?.lastName }}
                      </h3>
                      <!-- <h3 v-else>
                        {{ userInfo?.companyInfo?.firstName }} {{ userInfo?.companyInfo?.lastName }}
                      </h3> -->
                      <h4 v-if="userInfo?.userInfo?.userType == '1'">
                        {{ $t('navigationBar.IndivdualAccount') }}
                      </h4>
                      <h4 v-else>
                         {{ $t('navigationBar.GroupAccount') }}
                      </h4>
                    </div>
                  </div>
                </div>
              </el-dropdown-item>
              <div class="henggang"></div>
              <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
                <svg t="1723629044985" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5445" width="2.14rem" height="2.14rem">
                  <path
                    d="M899.64 897.715c-7.238-108.133-60.68-208.738-146.61-276.032l-5.165-3.568-0.047 0.07c-4.887-2.989-10.458-4.587-16.193-4.587-19.702 0-31.458 9.498-31.458 25.412 0 9.266 4.285 17.975 11.477 23.883l-0.08 0.139 4.562 3.266c72.065 51.519 112.638 129.653 120.584 232.273l0.085 1.12a31.507 31.507 0 0 0-0.116 2.612c0 17.341 14.058 31.4 31.4 31.4 16.76 0 30.45-13.13 31.35-29.665h0.624l-0.412-6.323z m-101.124-525.92c0-156.107-128.53-283.118-286.525-283.118S225.465 215.688 225.465 371.796c0 84.11 37.191 162.57 102.378 216.66-117.017 62.453-194.688 181.59-203.48 313.119l-0.362 5.483c-0.007 0.113-0.016 0.226-0.022 0.34l-0.033 0.5h0.02c-0.009 0.267-0.02 0.533-0.02 0.802 0 14.703 11.918 26.622 26.622 26.622 14.703 0 26.623-11.918 26.623-26.622 0-0.27-0.013-0.535-0.02-0.802h0.554l0.417-5.468c9.648-124.998 88.871-234.45 202.112-279.553 33.81 15.706 85.42 32.06 131.715 32.06 42.89 0 84.54-9.45 124.199-28.307l29.049-16.863 23.72-15.567c69.63-54.203 109.579-135.28 109.579-222.404zM511.99 597.932c-126.248 0-228.95-101.462-228.95-226.158 0-124.673 102.701-226.112 228.95-226.112 126.26 0 228.973 101.439 228.973 226.112-0.001 124.696-102.714 226.158-228.973 226.158z"
                    p-id="5446" fill="#1A2332"></path>
                </svg>
                <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/myAccount')">{{ $t('AccountCenterMenu.Account') }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
                <svg t="1723629413656" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6188" id="mx_n_1723629413658" width="1.92rem"
                  height="1.92rem">
                  <path
                    d="M85.333333 34.133333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V68.266667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V68.266667a68.266667 68.266667 0 0 1 68.266666-68.266667z m119.466667 136.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m0 392.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m136.533333-324.266667a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4z m0 392.533333a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4z m-136.533333 392.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m136.533333 34.133333a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4zM85.333333 392.533333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V426.666667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V426.666667a68.266667 68.266667 0 0 1 68.266666-68.266667z m0 392.533333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V785.066667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V785.066667a68.266667 68.266667 0 0 1 68.266666-68.266667z"
                    fill="#1A2332" p-id="6189"></path>
                </svg>
                <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/companiesViewed?type=1')">{{ $t('AccountCenterMenu.MyDatabase') }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item id="idR5VZA6" v-if="userInfo?.userInfo?.userType == '3'" class="ubgvGhd xiao ut7Z1e7">
                <svg t="1733991316703" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="9598" width="1.92rem" height="1.92rem">
                  <path
                    d="M700.472 624.178c-34.774-34.774-75.275-62.079-120.379-81.156a377.62 377.62 0 0 0-40.215-14.395c18.671-10.183 35.995-23.096 51.453-38.554 42.382-42.382 65.723-98.731 65.723-158.668s-23.341-116.286-65.723-158.668c-42.381-42.381-98.73-65.722-158.667-65.722s-116.287 23.341-158.668 65.722c-42.382 42.382-65.723 98.731-65.723 158.668s23.341 116.287 65.723 158.668c15.458 15.458 32.782 28.371 51.453 38.554a377.4 377.4 0 0 0-40.215 14.395c-45.103 19.077-85.604 46.382-120.378 81.156-34.775 34.774-62.08 75.276-81.157 120.379-19.756 46.709-29.773 96.312-29.773 147.43 0 13.808 11.193 25 25 25s25-11.192 25-25c0-181.267 147.471-328.738 328.738-328.738 181.266 0 328.738 147.472 328.738 328.738 0 13.808 11.193 25 25 25s25-11.192 25-25c0-51.118-10.018-100.721-29.773-147.43-19.078-45.103-46.383-85.605-81.157-120.379zM258.273 331.404c0-96.159 78.231-174.39 174.391-174.39 96.159 0 174.39 78.231 174.39 174.39s-78.231 174.391-174.39 174.391c-96.16 0-174.391-78.232-174.391-174.391z"
                    p-id="9599" fill="#1A2332"></path>
                  <path
                    d="M949.595 723.902c-15.027-41.062-37.593-78.38-67.072-110.92-29.479-32.54-64.394-58.672-103.775-77.67a337.59 337.59 0 0 0-28.944-12.317c14.958-7.855 29.021-17.659 41.87-29.301 39.892-36.138 63.322-85.648 65.976-139.409 2.654-53.761-15.787-105.338-51.925-145.229-36.139-39.891-85.648-63.322-139.41-65.976-13.783-0.672-25.521 9.947-26.202 23.737-0.681 13.79 9.947 25.521 23.737 26.202 40.422 1.995 77.647 19.612 104.819 49.605 27.172 29.993 41.037 68.772 39.041 109.194-1.995 40.422-19.611 77.647-49.604 104.819-28.099 25.455-63.902 39.232-101.549 39.23-2.539 0-5.093-0.063-7.646-0.189-13.786-0.677-25.521 9.947-26.202 23.737a25.25 25.25 0 0 0 0.061 3.307 25.096 25.096 0 0 0-0.386 3.283c-0.681 13.79 9.947 25.521 23.737 26.202 76.875 3.795 147.671 37.299 199.347 94.341s78.045 130.793 74.25 207.668c-0.681 13.79 9.947 25.521 23.737 26.202 0.42 0.021 0.837 0.031 1.253 0.031 13.24 0 24.289-10.398 24.949-23.769 2.249-45.579-4.501-90.253-20.062-132.778z"
                    p-id="9600" fill="#1A2332"></path>
                </svg>
                <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/userGroup')">{{ $t('AccountCenterMenu.OrganizationalManagement') }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item id="ceec8d" class="ubgvGhd xiao">
                <svg t="1723629515493" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="6496" width="1.92rem" height="1.92rem">
                  <path
                    d="M512 896c212.078933 0 384-171.921067 384-384s-171.921067-384-384-384-384 171.921067-384 384 171.921067 384 384 384z m0 42.666667c-235.639467 0-426.666667-191.0272-426.666667-426.666667S276.360533 85.333333 512 85.333333s426.666667 191.0272 426.666667 426.666667-191.0272 426.666667-426.666667 426.666667z"
                    fill="#1A2332" p-id="6497"></path>
                  <path
                    d="M512 797.866667c157.879467 0 285.866667-127.9872 285.866667-285.866667s-127.9872-285.866667-285.866667-285.866667-285.866667 127.9872-285.866667 285.866667 127.9872 285.866667 285.866667 285.866667z m0 42.666666c-181.444267 0-328.533333-147.089067-328.533333-328.533333s147.089067-328.533333 328.533333-328.533333 328.533333 147.089067 328.533333 328.533333-147.089067 328.533333-328.533333 328.533333z"
                    fill="#1A2332" p-id="6498"></path>
                  <path
                    d="M533.333333 683.968c41.365333-10.346667 72.644267-47.044267 74.210134-91.7888 1.890133-54.161067-40.4864-99.605333-94.651734-101.495467a21.589333 21.589333 0 0 0-2.133333 0.029867 21.589333 21.589333 0 0 0-2.129067-0.1792c-28.258133-0.989867-50.368-24.695467-49.3824-52.957867 0.9856-28.258133 24.695467-50.368 52.957867-49.3824 28.258133 0.989867 50.368 24.695467 49.378133 52.957867a21.333333 21.333333 0 0 0 42.641067 1.489067c1.578667-45.047467-28.864-83.7888-70.890667-94.3232V328.533333a21.333333 21.333333 0 1 0-42.666666 0v19.042134c-41.088 8.8064-72.5248 44.612267-74.0608 88.512-1.809067 51.810133 38.724267 95.274667 90.5344 97.088 0.721067 0.0256 1.4336 0.0128 2.133333-0.034134 0.699733 0.093867 1.408 0.157867 2.133333 0.183467 30.613333 1.066667 54.562133 26.752 53.495467 57.365333-1.066667 30.6176-26.752 54.570667-57.3696 53.499734-30.613333-1.066667-54.5664-26.752-53.495467-57.3696a21.333333 21.333333 0 1 0-42.641066-1.489067c-1.706667 48.917333 32.6912 90.722133 79.2704 99.754667V704a21.333333 21.333333 0 1 0 42.666666 0v-20.032z"
                    fill="#1A2332" p-id="6499"></path>
                </svg>
                <!-- lockType == 0 ? hasPrivilege = true : -->
                <span id="cb4014" class="u9qMull"
                
                  @click=" gotoUSer('account/invoiceDownload')">{{ $t('AccountCenterMenu.BillingandPayment') }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
                <svg t="1733991430414" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="10527" width="2rem" height="2rem">
                  <path
                    d="M942.08 519.68c0-33.28-2.56-61.44-10.24-81.92 2.56-20.48-10.24-35.84-30.72-40.96h-2.56c-35.84-7.68-61.44-25.6-81.92-61.44-17.92-30.72-23.04-66.56-10.24-99.84 7.68-15.36 2.56-35.84-12.8-48.64-38.4-35.84-87.04-64-140.8-81.92-15.36-7.68-35.84-2.56-48.64 12.8-23.04 28.16-56.32 43.52-94.72 43.52-33.28 0-66.56-15.36-94.72-43.52-17.92-17.92-35.84-15.36-48.64-12.8-56.32 20.48-99.84 46.08-135.68 79.36-17.92 10.24-23.04 30.72-15.36 46.08 10.24 38.4 7.68 74.24-10.24 104.96-15.36 30.72-46.08 51.2-81.92 61.44-2.56 0-5.12 0-5.12 2.56-12.8 7.68-23.04 17.92-25.6 30.72v2.56c-5.12 28.16-10.24 53.76-10.24 84.48 0 33.28 2.56 61.44 10.24 81.92-2.56 15.36 5.12 30.72 28.16 40.96h2.56c35.84 7.68 61.44 25.6 81.92 61.44 17.92 30.72 23.04 66.56 10.24 99.84-7.68 15.36-2.56 35.84 12.8 48.64 35.84 33.28 84.48 64 140.8 84.48h2.56c2.56 0 2.56 2.56 5.12 2.56h5.12c12.8 0 25.6-5.12 35.84-15.36 23.04-28.16 56.32-43.52 94.72-43.52 33.28 0 66.56 15.36 94.72 43.52 10.24 10.24 20.48 15.36 33.28 15.36 5.12 0 12.8 0 17.92-2.56 58.88-23.04 99.84-48.64 138.24-81.92 15.36-10.24 23.04-30.72 15.36-46.08-10.24-38.4-7.68-74.24 10.24-104.96 15.36-30.72 46.08-51.2 81.92-61.44 2.56 0 5.12 0 5.12-2.56 12.8-7.68 23.04-17.92 25.6-30.72v-2.56c5.12-28.16 7.68-56.32 7.68-84.48zM140.8 445.44c48.64-12.8 89.6-43.52 112.64-84.48 23.04-43.52 30.72-92.16 17.92-140.8 33.28-28.16 71.68-51.2 117.76-69.12 38.4 35.84 81.92 56.32 130.56 56.32 51.2 0 99.84-20.48 130.56-56.32 43.52 15.36 81.92 38.4 115.2 69.12-12.8 51.2-7.68 99.84 17.92 140.8 23.04 43.52 61.44 74.24 110.08 87.04 5.12 20.48 7.68 46.08 7.68 71.68 0 20.48-2.56 40.96-7.68 69.12-51.2 15.36-89.6 46.08-110.08 87.04-23.04 43.52-30.72 92.16-17.92 140.8-33.28 28.16-71.68 51.2-117.76 69.12-38.4-35.84-84.48-53.76-130.56-53.76-51.2 0-97.28 20.48-130.56 56.32-43.52-15.36-81.92-38.4-115.2-69.12 12.8-51.2 7.68-99.84-17.92-140.8-23.04-43.52-61.44-74.24-110.08-87.04-5.12-20.48-7.68-48.64-7.68-71.68-2.56-25.6 0-46.08 5.12-74.24z"
                    p-id="10528" fill="#1A2332"></path>
                  <path
                    d="M670.72 463.36c-5.12-12.8-17.92-20.48-30.72-17.92-12.8 5.12-20.48 20.48-15.36 33.28 7.68 20.48 7.68 46.08 0 74.24-10.24 28.16-30.72 51.2-56.32 66.56-28.16 12.8-58.88 15.36-87.04 5.12-28.16-10.24-51.2-30.72-66.56-56.32-12.8-28.16-15.36-58.88-5.12-87.04 10.24-28.16 30.72-51.2 56.32-66.56 28.16-12.8 58.88-15.36 87.04-5.12 12.8 5.12 28.16-2.56 33.28-15.36 5.12-12.8-2.56-28.16-15.36-33.28-40.96-15.36-87.04-12.8-128 7.68s-71.68 53.76-84.48 94.72c-15.36 40.96-12.8 87.04 7.68 128s53.76 71.68 94.72 84.48c15.36 5.12 35.84 10.24 53.76 10.24 71.68 0 133.12-46.08 156.16-112.64 10.24-38.4 10.24-74.24 0-110.08z"
                    p-id="10529" fill="#1A2332"></path>
                </svg>
                <span id="id92hCgF" class="u9qMull"
                  @click="lockType == 0 ? hasPrivilege = true : gotoUSer('/account/UserSettings')">{{ $t('AccountCenterMenu.UserSettings') }}
                </span>
              </el-dropdown-item>
              <el-dropdown-item id="idR5VZA6" class="ubgvGhd xiao ut7Z1e7">
                <svg t="1733991466296" class="icon uc68vlP" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="10827" width="2rem" height="2rem">
                  <path
                    d="M506.550742 1024h-3.232833a242.46251 242.46251 0 0 1-173.225993-75.702184 26.940279 26.940279 0 1 1 39.063404-37.177584A188.581952 188.581952 0 0 0 645.023776 909.773218 26.940279 26.940279 0 0 1 684.895388 945.873191a244.078927 244.078927 0 0 1-178.344646 78.126809zM900.956425 834.879242h-781.268087a94.290976 94.290976 0 0 1 0-188.581952 13.739542 13.739542 0 0 0 13.739542-13.470139v-255.663247a377.163904 377.163904 0 0 1 754.327808 0v255.663247a13.739542 13.739542 0 0 0 13.739542 13.470139 94.290976 94.290976 0 0 1 0 188.581952zM510.322381 56.843988A323.283346 323.283346 0 0 0 187.039035 377.163904v255.663247a67.6201 67.6201 0 0 1-67.6201 67.350697 40.410418 40.410418 0 0 0 0 80.820837h781.268087a40.410418 40.410418 0 0 0 0-80.820837 67.6201 67.6201 0 0 1-67.081294-67.350697v-255.663247A323.283346 323.283346 0 0 0 510.322381 56.843988z"
                    fill="#1A2332" p-id="10828"></path>
                </svg>
                <span id="id92hCgF" class="u9qMull" @click="gotoUSer('/account/notifications')">{{ $t('AccountCenterMenu.Messages') }}
                </span>
              </el-dropdown-item>


              <div id="g2bc16" class="henggang"></div>
              <el-dropdown-item id="cf0560" class="ubgvGhd sign">
                <svg id="id2MZcZM" class="icon uc68vlP" t="1719479218530" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="5906" width="2.14rem" height="2.14rem">
                  <path id="idZPpQuP"
                    d="M514.616594 860.266915c-200.014406 0-362.737488-162.724105-362.737488-362.738511 0-111.74606 50.379411-215.605499 138.222061-284.947797 5.988388-4.727675 14.676257-3.705392 19.402909 2.282996 4.727675 5.988388 3.705392 14.675234-2.282996 19.402909-81.162508 64.070224-127.711683 160.024623-127.711683 263.261892 0 184.779424 150.328797 335.109244 335.108221 335.109244 184.78147 0 335.112314-150.328797 335.112314-335.109244 0-103.307877-46.587038-199.285812-127.815037-263.323291-5.991458-4.723581-7.019881-13.409404-2.296299-19.400862 4.724605-5.991458 13.412474-7.017834 19.400862-2.296299 87.917352 69.309552 138.339742 173.195597 138.339742 285.020452C877.359198 697.54281 714.633047 860.266915 514.616594 860.266915zM514.676969 443.88567c-7.629771 0-13.814634-6.184863-13.814634-13.814634L500.862335 157.74572c0-7.629771 6.184863-13.814634 13.814634-13.814634s13.814634 6.184863 13.814634 13.814634l0 272.325315C528.491603 437.700807 522.30674 443.88567 514.676969 443.88567z"
                    fill="#1A2332" p-id="5907"></path>
                </svg>
                <span id="c2ced8" class="u9qMull uuXabem" @click="signOutAccount">{{  $t('MyAccount.SignOut') }}
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div id="cfab98" style="height: 2.8571em;" @click="AIseach" class="right_menu_box ub08be">
        <img id="g1287d" class="uf64b2" src="../../assets/images/aiimg.png" alt="" />
      </div>
    </div>
 
    <!-- 注释标记 -->
    <div id="c943c3" v-show="isShowChat" class="index_chart_gpt">
      <gui_chart id="gdf7da" @hide="hide($event)"> </gui_chart>
    </div>
    <Perfectdata :loginAndCreatePop.sync="Perfectdatalog"></Perfectdata>

    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <el-dialog :visible.sync="hasPrivilege" center :close-on-click-modal="true" @close="chasPrivilegeDialog"
      custom-class="dialog_normalsuo dialog_normalpower" :append-to-body="true">
      <div>
         <div class="detail_cont">
        <div class="flex_center">
             <img class="powerdengpao" src="@/assets/images/powerdengpao.png" alt="">
        </div>
          <div class="detail_cont_text">
        The feature you’re attempting to access is part of our premium membership benefits. To gain access to this feature and enjoy full access to premium features, please subscribe to our membership plan.
          </div>

        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export btn_exportCCC" @click="hasPrivilege = false">OK</el-button>
        <el-button class="btn_export" @click="$router.push({
          path: '/index/addCredit',
        })">Subscribe</el-button>
      </div>
    </el-dialog>
    <OperationWarning></OperationWarning>
    <RouterDrawe :RouterDrawer="drawer" @closeCloseDialog="clossuoDialog($event)"></RouterDrawe>

  </div>
  <!--srcviewshomeindexvuehtmlEnd-->
</template>
<script>
// interfaceCode
//importStart
import { getqueryList, getNotificationList, markAllAsRead, getqueryaddList, getqueryremoveList ,companyView} from "@/api/userApi";
import { LoginOut } from "@/api/api.js";
import bus from "../../components/bus";
import Login from "../../components/login.vue";
import Perfectdata from "../../components/PerfectData.vue";
import gui_card from "../../components/gui_card/gui_card.vue";
import { mixins1 } from "../../mixins/index";
import gui_chart from "../../components/gui_chart/gui_chart.vue";
//importEnd
import { getCountryCollection, getUserSimpleInfo } from "@/api/companyApi.js";
import { searchCompany, productSearch, searchTradeHscode } from "@/api/searchApi.js";
import RouterDrawe from '../../components/router-drawer/drawer.vue'
    import OperationWarning from "@/components/power/OperationWarning.vue";
    import { mapGetters } from 'vuex'
export default {
  mixins: [mixins1],
  name: "",
  props: {

  },
  components: {
    gui_chart,
    Login,
    gui_card,
    Perfectdata,
    RouterDrawe,
    OperationWarning,
  },
  created() {

    //登陆状态
    this.token ? (this.loginStatus = true) : (this.loginStatus = false);
    //登陆状态
    bus.$on("handleLogin", (loginCheck) => {

      // location.reload();
      this.loginStatus = loginCheck;
      this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      this.imageUrl = JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
        ? ""
        : 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg
      this.getUserSimpleInfoList()
      this.getqueryListDetale()
      this.getNotificationListDetali()


    });
    if (this.token) {
    this.companyViewPower()

      this.getUserSimpleInfoList()
      this.getqueryListDetale()
      this.getNotificationListDetali()
      this.imageUrl = JSON.parse(localStorage.getItem('userInfoImg')) == undefined ? this.imageUrl : JSON.parse(localStorage.getItem('userInfoImg'))
    }
  },
  mounted() {
    this.getAllCountry();
          this.selectLanguage({countryCode:this.$store.state.app.lang})
    this.$i18n.locale=this.$store.state.app.lang
         this.$store.dispatch("app/setLang", this.$i18n.locale)
  },

  data() {
    return {
      Keyword: true,
      drawer:false,
      hasPrivilege: false,
      items: [1, 2, 3, 4, 5],
      activeIndex: 0,
    
      Newlist: [],
      RedNews: [],
      ExpireDate: '',
      Vips: [],
      searchStr: "",
      AvailablePoints: 0,
      lockType: 0,
      percentage: 0,

      // isShowChannel
      isShowChannel: false,
      tradeSelect: 'HsCode',
      placeholder: "Enter company name",
      countryImg: "",
      tabCountryList: [],
      countryCode: '',
      countryCode1: '',
      countryName: "", //选中国家
      tabActiveName: "", //选择的区域
      placeholderTrade: "Search by",
      headPortrait: false,
      languageList: [
        {
          countryCode: 'en',
          countryCodeImg:'GB',
          countryName: 'English',
          color: true

        },
        {
          countryCode: 'jp',
            countryCodeImg:'JP',
          countryName: 'Japanese',
          color: false

        },
        // {
        //   countryCode:'de',
        //   countryCodeImg:'DE',
        //   countryName:'German',

        // },
        // {
        //   countryCode:'fr',
        //  countryCodeImg:'FR',
        //   countryName:'France',

        // },
         
        //  {
        //   countryCode:'es',
        //  countryCodeImg:'ES',
        //   countryName:'Spain',

        // },
        //  {
        //   countryCode:'it',
        //  countryCodeImg:'IT',
        //   countryName:'Italy',

        // },
        //  {
        //   countryCode:'nl',
        //  countryCodeImg:'NL',
        //   countryName:'Netherlands',

        // },
        // {
        //   countryCode:'pt',
        //  countryCodeImg:'PT',
        //   countryName:'Portugal',

        // },
        

      ],
      // existingList
      existingList: [

      ],
      // paidList
      paidList: [

      ],
      // followingName
      followingName: "explore",
   
    
      //
      isShowChat: false,
      loginDialog: false, //登录弹框
      loginStatus: false, //登录状态,
      Perfectdatalog: false, //收集信息
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      token: localStorage.getItem("token"),
      userRole: {},
      percentageerr: false,

      moreclose: false,
      restaurants: [],
      state: '',
      timeout: null,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : 'https://www.csibizsearch.com/csi/usercenter/download/resource?resource=' + JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,

      // srcviewshomeindexvueDataEnd
    };
  },

  methods: {
    OpenWhatNew(){
      let routeData = this.$router.resolve({
        path: '/whatIsNew'
      });

      window.open(routeData.href, '_blank');
    },
       selectLanguage(item){
      this.languageList.map(ite=>{
        if(ite.countryCode==item.countryCode){
          ite.color=true
        }else{
          ite.color=false
        }
      })
 this.$i18n.locale=item.countryCode
       sessionStorage.setItem('language',  this.$i18n.locale)

         this.$store.dispatch("app/setLang", this.$i18n.locale)
   
    },
         companyViewPower(){
      companyView({
   
      }).then(res=>{
        if(!res.data){
                this.$store.dispatch("app/SetOperationWarning", true)
          // this.$bus.$emit('show-OperationWaring-dialog', '');
          
        }
      })
    },
    OperationWarningShow(){
      this.$bus.$emit('show-OperationWaring-dialog', '');
    },
    // 九宫格
    clossuoDialog(value){
      this.drawer=value
    },
    gotccsibizinfo(value) {
      window.open(value, '_blank')
    },
    // onSlideChange($event) {
    // },
    beforeEnter(el) {
      el.classList.add('active');
    },
    leave(el) {
      el.classList.remove('active');
    },
    labelClick(label) {
      this.countryName = label;

    },
 
  

    gotomessage(item) {
      this.$router.push({
        path: '/account/Notifications',
        query: {
          id: item.id
        }
      });
    },
    isShowChannelmethad() {
      this.isShowChannel = true
    },
    async getAllCountry() {
      let countryCode = ''
      // localStorage.setItem('countryList',JSON.stringify(countryImgList))
      // 处理缓存问题
      
      if (JSON.parse(localStorage.getItem("countryList"))) {
        this.tabCountryList = JSON.parse(localStorage.getItem("countryList"));
        let list = this.tabCountryList;
        list.forEach((item, index) => {
          item.countryList.forEach((it) => {
            let countryImg = "";
            if (it.urlBanner == null) {
              countryImg = "../../../static/imagev2/zanwutupian.png";
            } else {
              countryImg = it.urlBanner.split("../../../static")[1];
            }
            // let flag = require('../../static' + countryImg);
            let flag = "";
          try {
                flag = require("../../../static" + countryImg);
              } catch (error) {
                flag = "../../../static/imagev2/undefined.png";
                // 提供一个默认值或者其他处理方式
                // flag = require("../../../static" + countryImg);
              }
            it.urlBanner = flag;
            if (countryCode && it.countryCode == countryCode) {
              this.countryName = it.nameEn;
              this.countryImg = it.urlBanner;
            }
          });
        });
      } else {
        // 清理缓存后重新请求页面
        let res = await getCountryCollection();
       
        if (res && res.code) {
          let countryImgList = res.data.rows;
          this.$store.state.countryImgList = JSON.parse(
            localStorage.getItem("countryList")
          ); //res.data.rows
          this.tabCountryList =
            JSON.parse(localStorage.getItem("countryList")) == null
              ? res.data.rows
              : JSON.parse(localStorage.getItem("countryList"));

          localStorage.setItem("countryList", JSON.stringify(countryImgList));

          let list = this.tabCountryList;

          list.forEach((item, index) => {
            item.countryList.forEach((it) => {
              let countryImg = "";
              // /imagev2/zanwutupian.png
              if (it.urlBanner == null) {
                countryImg = "../../../static/imagev2/zanwutupian.png";
              } else {
                countryImg = it.urlBanner.split("../../../static")[1];
              }
              // let flag = require('../../static' + countryImg);
              let flag = "";
              try {
                flag = require("../../../static" + countryImg);
              } catch (error) {
                flag =require( "../../../static/imagev2/undefined.png");
                // 提供一个默认值或者其他处理方式
                // flag = require("../../../static" + countryImg);
              }
              it.urlBanner = flag;
              if (countryCode && it.countryCode == countryCode) {
                this.countryName = it.nameEn;
                this.countryImg = it.urlBanner;
              }
            });
          });
        }
      }
    },
    AIseach() {
      if (this.loginStatus) {
        if (this.lockType == 2 || this.lockType == 3) {
          this.isShowChat = !this.isShowChat
        } else {
          this.hasPrivilege = true
        }
      } else {
        this.loginDialog = true
      }

    },
    chasPrivilegeDialog() {
      this.hasPrivilege = false
    },
    hide(value) {
      this.isShowChat = value

    },
    MarkRead() {
      markAllAsRead().then(res => {
        if (res.code == 200) {
          this.getNotificationListDetali()
          this.RedNews.length = 0
        }
      })
    },

    // 信息获取
    getNotificationListDetali() {
      getNotificationList().then(res => {
        if (res.code == 200) {
          this.Newlist = res.data
          if (this.Newlist.length > 0) {
            res.data.map(item => {
              if (item.hasRead == 0) {
                this.RedNews.push(item)

              }
            })
          }
        } else {
          this.Newlist = []
        }

      })
    },
    // 积分获取
    getUserSimpleInfoList() {
      getUserSimpleInfo().then(res => {
        if (res.code == 200) {
          if (res.data.certification != 1) {
            localStorage.setItem('renzheng', true)
          }
          this.AvailablePoints = res.data.availablePoints
          this.ExpireDate = res.data.expiration
          this.Vips = res.data.vips
          this.lockType = res.data.lockType
          this.$store.dispatch("app/setEquityType", res.data.availablePoints);

        }
      })

    },
    getqueryListDetale() {
      getqueryList().then(res => {
        if (res.code == 200) {
          let showList = []
          let showListtwo = []
          res.data.forEach(item => {
            showList.push({
              id: item.moduleId,
              name: item.screenName,
              type: item.screenName,
              isSelect: item.isShow,
              icon: item.icon
            })
            if (item.isShow == true) {
              showListtwo.push({
                id: item.moduleId,
                name: item.screenName,
                type: item.screenName,
                isSelect: item.isShow,
                icon: item.icon
              })
            }


          })
          this.existingList = showList

          this.paidList = showListtwo

        }
      })
    },


    gotoUSer(route) {
      this.$router.push({
        path: route,
      });
    },
    // insertMethod
    // srcviewshomeindexvueMethodStart
    // default
    Sign() {
      this.loginDialog = true;
    },

    default() { }, // 跳转搜索列表页面
    openList(str) {
      this.$store.dispatch("app/SetlabelCode", '');
      this.$store.dispatch("app/SetlabelCodeName", '');
      let Keyword = "";

      if (this.Keyword) {
        Keyword = 2;
      } else {
        Keyword = 1;
      }
      if (str) {
        this.$store.commit("setRefreshKey", new Date().getTime());
        this.$router.push({
          path: "/index/search/list/" + str + "/company",
          query: { searchname: str, companyCountry: this.countryCode, keword: Keyword },
        });
      } else {
        this.$router.push({
          path: "index/list/company",
        });
      }
    }, // deleteTool
    deleteTool(item) {
      let index = this.existingList.findIndex((item2) => item2.id == item.id);
      let paidListindex = this.paidList.findIndex((item3) => item3.id == item.id);

      this.existingList[index].isSelect = false


      if (index !== -1) {
        getqueryremoveList({
          moduleId: item.id
        }).then(res => {

        })
        this.paidList.splice(paidListindex, 1);
      }
      // item.isSelect = false;
    }, // addTool
    addTool(item) {

      let obj = this.existingList.find((item2) => item2.id == item.id);
      if (item.isSelect == false) {
        item.isSelect = true;
        getqueryaddList({
          moduleId: item.id
        }).then(res => {

        })
        this.paidList.push(JSON.parse(JSON.stringify(item)))
      }
    }, // taggleFlolwing
    taggleFlolwing(name) {
      this.followingName = name;
    },
    //Sign out 登出
    signOutAccount() {
      LoginOut({}).then((res) => {

        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });

          bus.$off("handleLogin");
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          window.location.href = "/";
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("renzheng");
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("renzheng");
          window.location.href = "/";
        }
      });
    },

    gotoOne(value) {
      window.open(value, '_blank')

    },
    goHome(){
            this.$router.push('/')
        },
    // srcviewshomeindexvueMethodEnd
  },

  computed: {
       ...mapGetters({
      lang: 'app/lang'
    }),
  
  },
};
</script>
<style scoped>
.margin-left30 {
  margin-left: 2.1428rem;
}






.u8c4dc {
  display: flex;

  height: 3.571rem;
  margin-top: 1.42857rem;
  margin-left: 1rem;
  margin-right: 2.85714286rem;
  align-items: center;
}

.u8220d {
  display: flex;
  align-items: center;
 
}

.u2042e {
  flex: auto;
}

.right_menu_box {

  margin-left: 2.1428rem;
  cursor: pointer;
}

.u0427c {
  display: flex;
  align-items: center;
  height: 2.428rem;
  padding-left: 0.714rem;
  padding-right: 0.714rem;
  padding-top: 0.21428571428571427rem;
  padding-bottom: 0.21428571428571427rem;
  box-sizing: border-box;
  border: 0.07142857142857142rem solid rgba(255, 255, 255, 0.5);
  border-radius: 1.142857rem;
}

.u84443 {
  margin-right: 0.45rem;
  color: #ffffff;
  font-size: 1.142857rem;
  text-align: center;
  line-height: 1.285rem;
  font-style: normal;
}

.ubbf89 {
  width: 1.571rem;
  height: 1.571rem;
  /* background-color: rgba(255, 255, 255, 1); */
  border-bottom-left-radius: 100rem;
  border-top-left-radius: 100rem;
  border-top-right-radius: 100rem;
  border-bottom-right-radius: 100rem;
  overflow-y: hidden;
  overflow-x: hidden;
}

.uf64b2 {
  /* margin-top: 1.42857em; */
  height: 2.8571rem;
  width: 3.714rem;
}

.u63509 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 9.5%;
  /* margin-top: 12.14285714rem; */
}

.u11f46 {
  display: flex;
  /* margin-top: 2.857142857142857rem;
  margin-bottom: 2.857142857142857rem; */
}

.u5faed {
  display: flex;
  align-items: center;
  width: 71.4285714rem;
  height: 5rem;
  padding-left: 1.4285714rem;
  box-shadow: 0rem 0.14285714285714285rem 0.714em 0rem rgba(42, 104, 142, 0.18);
  background: #ffffff;
  border-radius: 2.5rem;

}



.u0a08d {
  width: 0;
  flex: auto;
}



.unrH9VJ {
  font-size: 1.142857rem;
  color: #000000;
  line-height: 0.857rem;
  text-align: left;
  font-style: normal;
  margin-right: 1.42857rem;
}

.u606de {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: none;
  padding: 0.714em 0rem;
  font-size: 1.2857143rem !important;

}

.u7fb7a {
  width: 1em;
  margin-right: 0.5rem;
}

.ucc8d2 {
  color: rgba(26, 35, 50, 1);
  font-size: 1.142857rem;
}

.u75237 {
  display: flex;
  height: 22.328rem;
}

.u5efe2 {
  width: 38.41%;
  height: 100%;
  background: #eeeeee;
  border-radius: 0.857rem 0.857rem 0rem 0rem;
  position: relative;
  margin-right: 1rem;
  cursor: pointer;

}

.u326e0 {
  width: 100%;
  height: 100%;
  border-radius: 0.857rem;
}

.uc6717 {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-left: 1.428rem;
  padding-right: 1.428rem;
  padding-top: 0.714rem;
  padding-bottom: 0px;
  position: relative;
  /* background: linear-gradient(180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(3, 3, 3, 0.56) 100%); */
  border-radius: 0.857rem ;
  overflow: hidden;
  position: absolute;
  left: 0rem;
  flex-direction: column;
  z-index: 10;
  bottom: 0rem;
}

.uc9f98 {
  font-family: "DMSans DMSans";
  font-weight: bold;
  font-size: 1.714rem;
  color: #FFFFFF;
  /* line-height: 2.4285714285714284rem; */
  text-shadow: 0rem 0.14285714285714285rem 0.14285714285714285rem rgba(0, 0, 0, 0.1);
  text-align: justify;
  font-style: normal;


}

.ud8c2c {
  position: absolute;
  bottom: 1.42857143rem;
  padding: 0px 20px;
    font-family: "DMSans DMSans";
    font-size: 1.2857143rem;
    color: #FFFFFF;
    /* line-height: 27px; */
    opacity: 0.9;
    text-shadow: 0rem 0.14285714285714285rem 0.14285714285714285rem rgba(0, 0, 0, 0.8);
    text-align: left;
    font-style: normal;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    overflow: hidden;
    text-overflow: ellipsis;
}

.u703ad {
  display: flex;
  width: 0;
  flex: auto;
}

.u4805e {
  display: flex;
  width: 0;
  height: 100%;
  background: #eeeeee;
  border-radius: 0.857rem 0.857rem ;
  flex-direction: column;
  flex: auto;
  margin-right: 0.5rem;
}

.uac3ec {
  height: 12rem;
}

.u2e0e9 {
  width: 100%;
  height: 100%;
}

.u714d2 {
  height: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.714rem;
  padding-bottom: 0.714rem;
  flex: auto;
}

.u97f5f {
  margin-bottom: 0.42857rem;
  font-size: 12px;
  color: #666666;
  line-height: 1.142857rem;
  text-align: left;
  font-style: normal;
}

.u714d2 p {
  font-family: "DMSans DMSans";
  /* font-weight: bold; */
  font-size: 14px;
  color: #000000;
}

.u42764 {
  margin: 0.714rem 0rem;
  font-weight: normal;
  font-family: "DMSans DMSans";
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 1.2857rem;
  text-align: left;
  font-style: normal;
  /* 最大高度为两行的高度 */
}

.max2clamp {
  display: -webkit-box;
  /* 使用 flexbox 布局 */
  -webkit-box-orient: vertical;
  /* 垂直排列 */
  -webkit-line-clamp: 2;
  /* 限制为两行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 使用省略号 */

  max-height: 5rem;
}

.ua85bb {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  padding-bottom: 0.714rem;
}

.u3eb4b {
  width: 8.57rem;
  height: 8.57rem;
}

.ubab9d {
  margin-bottom: 0.42857rem;
  text-align: center;
}

.u6ec5c {
  text-align: center;
  font-size: 12px;
  color: #999999;
  line-height: 1rem;
}

.index_chart_gpt {
  width: 42.8571429rem;
  /* height: calc(100% - 6.5rem); */
  min-height: 50rem;
  position: fixed;
  right: 0rem;
  top: 0rem;
  background: #ffffff;
  z-index: 999999;
}

.u0fcfc input {
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  border-style: none;
}

.u6db8d .u270ed {
  margin-right: 1.42857rem;
}

.u6db8d .u74fe0 {
  color: rgba(8, 8, 8, 1);
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u47dc6 .active {
  border: 0.07142857142857142rem solid #1290c9;
}

.u807e8 .active {
  color: rgba(18, 144, 201, 1);
}

.u606de .active {
  color: rgba(18, 144, 201, 1);
  fill: #1290c9;
}

/* 登陆 */
/* 菜单 */
.head_menu_box {
  width: 100%;
  height: 3.571em;
  background: #fff;
  box-shadow: 0rem 0.14285714285714285rem 0.42857142857142855rem 0.07142857142857142rem rgba(10, 33, 57, 0.14);
}

.head_menu_list {
  display: flex;
  justify-content: center;
}

.head_menu_list /deep/ .el-radio-button__inner {
  padding: 1.1428571428571428rem 0rem 0.857em;
}

.head_menu_list /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #1290c9;
  background-color: #fff;
  border-color: #1290c9;
  box-shadow: none;
}

.head_menu_item /deep/ .el-radio-button__inner {
  border: none;
  border-bottom: 0.14285714285714285rem solid transparent;
  border-radius: 0;
  line-height: 1.2857142857142858rem;
  font-size: 1rem;
  color: #022955;
}

.head_menu_item {
  line-height: 1.42857rem;
  font-size: 1rem;
  /* padding: 1.2857142857142858rem2.1428em 0.714em2.1428em; */
  text-align: center;
  /* margin: 02.1428em; */
  padding: 02.1428rem;
}

.search_option /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none !important;
}

.top_usage {
  padding: 1.0714285714285714rem 0.714rem;
  background: #f2f5f9;
  border-radius: 1rem;
  margin-bottom: 0.5rem;
}

.usage_prog {
  flex: 1;
}

.usage_ic {
  width: 20.42857rem;
  height: 20.42857rem;
  line-height: 20.42857rem;
  /* background: #ffffff; */
  border-radius: 50%;
  margin-right: 0.714rem;
  text-align: center;
  background-color: rgb(0, 49, 7);
}

.usage_ic img {
  width: 0.857rem;
  height: 0.857rem;
}

.usage_icone {
  background: #ffffff !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.usage_icone img {
  width: 1.142857rem;
  height: 1.142857rem;
}

.usage_txt {
  font-size: 1rem;
  color: #022955;
  margin-bottom: 0.5714285714285714rem;
}

.usage_total {
  font-size: 0.857rem;
  color: #8497ab;
}

.usage_used {
  margin-top: 0.5714285714285714rem;
  font-size: 0.857rem;
  color: #1290c9;
}

.acc_signout,
.top_acc_menu_box li a {
  display: block;
  padding: 0.5714285714285714rem 0.714rem;
  font-size: 1rem;
  color: #022955;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.acc_signout:hover,
.top_acc_menu_box li a:hover,
.top_acc_menu a.router-link-exact-active.router-link-active {
  color: #1290c9;
}

.acc_signout:hover,
.top_acc_menu_box li a:hover {
  background: #ebf2ff;
  border-radius: 1rem;
}

.head_login,
.acc_signout {
  cursor: pointer;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 3.5714285714285716rem !important;
  background-color: #fff;
  margin: auto;
  padding: 0;
}

.head_sign {
  cursor: pointer;
  color: #022955;
  line-height: 3.571rem;
}

.head_top_left {
  width: 11.571428571428571rem;
  height: 20.42857rem;
  cursor: pointer;
}

.switch_txt {
  font-size: 1rem;
  color: #ffffff;
  /* line-height: 1.142857rem; */
}



/deep/ .el-dropdown-menu__item {
  font-size: 1.42857rem !important;
  color: #1a2332;
}

/deep/ .el-badge__content {

  min-height: 1rem;
  min-width: 1.2857142857142858rem;
  border-radius: 50%;
  padding: 0rem;
}

/deep/ .el-badge__content--warning {
  background-color: #F56C6C;
  top: 1.2142857142857142rem !important;
  right: -0.35714285714285715rem !important;
  width: 1.42857rem;
  height: 1.42857rem;
  border-radius: 50%;
  font-size: 0.857rem;
  line-height: 1.42857rem;
}

.history_box-headborder {
  border-bottom: 0.07142857142857142rem solid #DDDDDD;
  padding-bottom: 0.714rem;


}

.history_box-head {
  font-size: 1.42857rem;
}

.history_box {
  height: 21.428rem;
  overflow-y: auto;
  padding-bottom: 2.857142857142857rem;
}

.item_title {
  padding: 1.4285714285714286rem 0rem;
  /* background-color: #f5f5f5; */
  /* margin-bottom: 0.714em; */
  border-bottom: 0.07142857142857142rem solid #dddddd;
}

.messageimg {
  height: 2.857142857142857rem;
  width: 2.857142857142857rem;
  border-radius: 50%;
}

.item_cont_txt {
  padding: 0.714em;
  border-radius: 0.42857rem;
  font-size: 1.142857rem;
  color: #1a2332;
  background-color: #f5f5f5;
  margin-top: 1rem;
}

.head-text {
  font-family: 'DMSans Bold';
  font-size: 1.2857142857142858rem !important;
  text-align: left;
  font-style: normal;
  color: #1a2332;
  line-height: 1.42857rem;
}

.icon {
  /* margin-right: 0.714em; */
}

.icon-time {
  font-size: 1rem;
  line-height: 1.6428571428571428rem;
  color: #999999;
  margin-top: 0.5714285714285714rem;
}

.message-right {
  margin-left: 1.42857rem;
}

.history_box_bottom {
  position: absolute;
  bottom: 0rem;
  padding-top: 1rem;
  background: #ffffff;
  width: 100%;
  border-top: 0.07142857142857142rem solid #dddddd;
}

.right-blue {
  margin-top: 0.5rem;
  width: 0.714rem;
  height: 0.714rem;
  background: #F56C6C;
  border-radius: 50%;
  padding-left: 0.714rem;
}

.srcviewslayoutheadervuecssEnd {}

.icontwo {
  margin-right: 0.714rem;
}

.postiverelatibve {
  position: relative;
}







.postiveaboust {
  position: absolute;
  right: -1em;
  top: 2.7857142857142856rem;
}

.avatar {
  width: 3.4285rem;
  ;
  height: 3.4285rem;
  ;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;
  /* font-size: 2.857rem; */
  font-size: 2.28571429rem;
  line-height: 3.4285rem;
  text-align: center;
  color: #a2a9b0;
  overflow: hidden;
}

.avatarnologin {
  height: 3.4285rem;

  width: 3.4285rem;
  border-radius: 50%;
  display: block;
  background: #f5f5f5;
  line-height: 3.4285rem;
  text-align: center;
  color: #a2a9b0;
  /* overflow: hidden; */
}

.avatarnologin_1 {
  font-size: 2.157rem;
}

.account-left-right {
  margin-left: 1.5714285714285714rem;
}

.account-left-right h3 {
  font-size: 1.2857143em;
  color: #1a2332;
  line-height: 1.7142857142857142rem;
}

.account-left {
  margin-bottom: 2.1428em;
}

.account-left-right h4 {
  font-size: 1.142857rem;
  color: #666666;
  margin-top: 0.42857rem;
}

.progress {
  margin-top: 1.42857em;
  margin-bottom: 0.714em;
}

.ExpireDate {
  font-size: 14px !important;
  color: #8497AB;
  line-height: 1.142857em;
  /* padding-bottom: 1.42857em; */
}

.ExpireDate :nth-of-type(1) {
  border-bottom: 0.07142857142857142rem solid #dddddd;

}

.Available {
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  margin-top: 1.142857em;
  margin-bottom: 1.42857em;
}

.henggang {
  height: 0.07142857142857142rem;
  margin: 0.21428571428571427rem 1.42857em;
  background-color: #dddddd;
}

.u1ba31 {
  width: 3.571em;
  height: 3.571em;
  overflow: hidden;
  border-radius: 50%;
}

.uc68vlP {
  margin-right: 1.142857em;
}

.flex_box {
  position: relative;
}

.right-blue {
  position: absolute;
  right: 0rem;
}


#g063ad {
 height: 2.425714rem;
  cursor: pointer;
}

#cfab98 {
  height: 2.857142857142857rem;
}

.icon {
  /* height: 20.42857em; */
}

/deep/ .el-input__inner {
  padding-left: 0.714rem;
  line-height: 100%;
  font-size: 1.285714rem;
}

/deep/ .el-input__inner::placeholder {
  color: #8497AB;
  /* 更改为您想要的颜色 */
  opacity: 1;
  /* 确保不透明度为 1 */
}

.activecolor {
  color: #1290c9;
}




/deep/ .el-carousel__indicators--horizontal {
  bottom: 0.5rem;
  width: 5.714285714285714rem;
  left: 52%;
}

/deep/ .el-carousel__indicator .el-carousel__button {
  height: 0.5714285714285714rem;
  outline: 0;
  width: 0.5714285714285714rem;
  border-radius: 50%;
}





.u9qMull {
  display: inline-block;
  width: 100%;
}

/* /deep/ #c308fb{
  padding-left: 2.0rem !important;
} */
/deep/ .el-input-group__prepend {
  width: 11rem;
  background-color: #FFFFFF;
  color: #1A2332;
  border-right: 1px solid #DDDDDD;
}

/deep/ .el-input-group--prepend .el-select .el-input__inner {
 font-size: 1.28571428571428rem;
  padding-right: 2.5rem;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

}

/deep/ .el-input-group--prepend .el-input__suffix {
  right: 0px;
}


 .menu-icon {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 28px;
  margin-right: 40px;
  cursor: pointer;
}
.menu-round-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.menu-round-con .menu-round-item {
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 3px;
  transition: all 0.3s ease-in-out;
}
  .menu-round-item {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
}
 .menu-icon:hover .menu-round-item:first-child {
  width: 100%;
  height: 4px;
}

  .menu-icon:hover
  .menu-round-item:nth-last-child(-n + 2) {
  width: 0px;
}






/* .u070db,
/deep/ .el-carousel__item {
  opacity: 0.4;


  transition: opacity 2s ease, ;
}

.u070db.active,
.is-active,
/deep/ .is-active {
  opacity: 1 !important;
} */




/* 穿透样式 */
/* /deep/ .swiper-slide-active {
  transform: scale(1.2); /* 可选动画增强效果 */
/* }  */

/*cssStart*/

/*cssEnd*/
</style>